// extracted by mini-css-extract-plugin
module.exports = {"checkboxGroup":"SortCheckboxGroup_checkboxGroup__2MZ_A","infoIcon":"SortCheckboxGroup_infoIcon__3lVja"};